import { Route, Routes, useLocation } from "react-router-dom";
import { Shell } from "./components/Shell";
import { AdminPage } from "./pages/AdminPage";
import { CatalogPage } from "./pages/CatalogPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { ConfirmationPage } from "./pages/ConfirmationPage";
import { JoinPage } from "./pages/JoinPage";
import { LandingPage } from "./pages/LandingPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ProductPage } from "./pages/ProductPage";
import { RoomPage } from "./pages/RoomPage";

function MarketingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/catalogo" element={<CatalogPage />} />
      <Route path="/experiencias/:slug" element={<ProductPage />} />
      <Route path="/checkout/:slug" element={<CheckoutPage />} />
      <Route path="/confirmacion/:orderId" element={<ConfirmationPage />} />
      <Route path="/unir" element={<JoinPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/privacidad" element={<PrivacyPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export function App() {
  const location = useLocation();
  if (location.pathname.startsWith("/sala/")) {
    return <Routes><Route path="/sala/:roomId" element={<RoomPage />} /><Route path="*" element={<NotFoundPage />} /></Routes>;
  }
  return <Shell><MarketingRoutes /></Shell>;
}
